var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMbriLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C8.468 0 6 2.468 6 5.5v2c0 .672 1 .648 1 0v-2C7 3.01 9.01 1 11.5 1S16 3.01 16 5.5v2c0 .668 1 .656 1 0v-2C17 2.468 14.532 0 11.5 0zm0 13C10.125 13 9 14.125 9 15.5c0 .77.406 1.445 1 1.914V18.5c0 .822.678 1.5 1.5 1.5s1.5-.678 1.5-1.5v-1.088c.594-.47 1-1.143 1-1.912 0-1.375-1.125-2.5-2.5-2.5zm0 1c.834 0 1.5.666 1.5 1.5 0 .536-.286 1.027-.75 1.295-.155.09-.25.255-.25.434v1.27c0 .286-.214.5-.5.5-.286 0-.5-.214-.5-.5v-1.27c0-.178-.095-.344-.25-.433-.464-.268-.75-.76-.75-1.297 0-.834.666-1.5 1.5-1.5zm-7-5C3.678 9 3 9.678 3 10.5v12c0 .822.678 1.5 1.5 1.5h14c.822 0 1.5-.678 1.5-1.5v-12c0-.822-.678-1.5-1.5-1.5zm0 1h14c.286 0 .5.214.5.5v12c0 .286-.214.5-.5.5h-14c-.286 0-.5-.214-.5-.5v-12c0-.286.214-.5.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbriLock);
export default __webpack_public_path__ + "static/media/mbri-lock.0b0b62bee308cdac2f961aa963c8d534.svg";
export { ForwardRef as ReactComponent };